const { gsap } = require('gsap');
const { ScrollTrigger } = require("gsap/ScrollTrigger");

const bootstrap = require('bootstrap');

if(screen.width > 768) {
    const tooltipTriggerList = document.querySelectorAll('[data-toggle="tooltip"]');
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
}

const ScrollEvents = function () {

	const elmToScroll = function (el) {
		var _this = el.attr('data-scrollto');
		scrollToElm(_this);
	}

	const scrollToElm = function (target, offSet=null) {
		gsap.to(window, {
			duration: 2,
			scrollTo: { y: ($(target).offset().top) - (offSet != null ? ($("#header").height() + 30) : +2) },//($(target).offset().top - document.querySelector("#header").scrollHeight)
			delay: 0,
			ease: 'Power4.easeInOut'
		});
	}

	/* =========================================================================== */

	const parallaxWebdoor = function (el) {

		if(!document.querySelector(el)) return;

        gsap.fromTo($(el).not(".no-plx").find('picture'),
            {
                yPercent: 0,
                // scale: 1,
            }, {
            yPercent: 35,
            // scale: .8,
            ease: "none",
            scrollTrigger: {
                trigger: el,
                start: "top top",
                end: "bottom -=20%",
                scrub: true
            }
        });
    }


	/* =========================================================================== */


	/* =========================================================================== */

	const listAnimate = () => {

		if (!document.querySelector('.wrap-thumb')) return;

		gsap.utils.toArray(".wrap-thumb").forEach(thumb => {
			gsap.to(thumb, {
				autoAlpha: 1,
				duration: 2,
				y: 0,
				scrollTrigger: {
					trigger: thumb,
					start: "top bottom",
					end: 'bottom bottom',
					scrub: 1
				}
			})
		})


	}

	/* =========================================================================== */
	/* =========================================================================== */


	fxTextTitles = () => {

		const captions = gsap.utils.toArray('.wrap-title-caption').forEach(caption => {

			const tl = gsap.timeline({

				scrollTrigger: {
					trigger: caption,
					start: "+=50 90%",
					end: "center 60%",
					scrub: 2,
					//markers: true,
					toggleActions: "play reverse play reverse",
				}

			});

				if($(caption).find('.title-small').length > 0) {
					tl.fromTo($(caption).find('.title-small'), {opacity: 0, duration: 1, y: 50},{ opacity: 1, duration: 0.8, y: 0 });
						//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
				}
				if($(caption).find('.title-default').length > 0) {
					tl.fromTo($(caption).find('.title-default'), {opacity: 0, duration: 1, y: 50},{ opacity: 1, duration: 0.8, y: 0 });
						//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
				}
				if($(caption).find('.text').length > 0) {
					tl.fromTo($(caption).find('.text'), {opacity: 0, duration: 1, y: 50},{ opacity: 1, duration: 0.8, y: 0 });
						//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)

				}


		})

	}

	zoomOutElm = () => {

		const elmsOut = gsap.utils.toArray('.zoomOutElm').forEach(elmOut => {

			const tl = gsap.timeline({

				scrollTrigger: {
					trigger: elmOut,
					start: "+=50 90%",
					end: "center 40%",
					scrub: 1,
					//markers: true,
					toggleActions: "play reverse play reverse",
				}

			});

				if($(elmOut).length > 0) {
					tl.fromTo($(elmOut), {opacity: 0, duration: .3, scale: 1.4},{ opacity: 1, duration: 0.3, scale: 1 });
						//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
				}
		})

	}

	introLeft = () => {
		const captions = gsap.utils.toArray('.intro-left').forEach(caption => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: caption,
					start: "+=50 90%",
					end: "center 40%",
					scrub: 2,
					//markers: true,
					toggleActions: "play reverse play reverse",
				}
			});
			if($(caption).length > 0) {
				tl.fromTo($(caption), {duration: 1, x: -100},{ duration: 0.8, x: 0 });
					//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
			}
		})

	}

	introUp = () => {
		const captions = gsap.utils.toArray('.intro-up').forEach(caption => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: caption,
					start: "+=50 90%",
					end: "center 40%",
					scrub: 2,
					//markers: true,
					toggleActions: "play reverse play reverse",
				}
			});
			if($(caption).length > 0) {
				tl.fromTo($(caption), { duration: 1, y: 100},{  duration: 0.8, y: 0 });
					//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
			}
		})

	}
	mozaico = () => {
		const captions = gsap.utils.toArray('.wrap-mosaic').forEach(caption => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: caption,
					start: "+=50 90%",
					end: "center 40%",
					scrub: 2,
					//markers: true,
					toggleActions: "play reverse play reverse",
				}
			});
			if($(caption).find('img').length > 0) {
				tl.fromTo($(caption).find('img'), { scale: 1.5},{  duration: 0.5, scale: 1 });
					//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
			}
		})

	}

	zoomInElm = () => {

		const elmsIn = gsap.utils.toArray('.zoomInElm').forEach(elmIn => {

			const tl = gsap.timeline({

				scrollTrigger: {
					trigger: elmIn,
					start: "+=50 90%",
					end: "center 60%",
					scrub: 2,
					//markers: true,
					toggleActions: "play reverse play reverse",
				}

			});

				if($(elmIn).length > 0) {
					tl.fromTo($(elmIn), {opacity: 0, scale: .8},{ opacity: 1, duration: .6, scale: 1 });
						//.to($(caption).find('.title, .text'), { opacity: 0, duration: 0.8, stagger: 0.1 }, 0.8)
				}
		})

	}

	const limitWhatsScroll = () => {

        gsap.to("#ico-whats", {
            y : -200,
            scrollTrigger : {
                trigger : "#limitWhats",
                start : "top bottom",
                end :  "bottom bottom",
                scrub : true,
                //markers : true
            }
        })
    }

	/* const expImage = (() => {

		gsap.utils.toArray(".revealUp").forEach(el => {

			gsap.fromTo(el,
				{
					//scale : 1.4,
					yPercent: 30
				}, {
				yPercent: 0,
				//scale: 1,
				autoAlpha: 1,
				ease: "none",
				scrollTrigger: {
					trigger: el,
					start: "top 100%",
					end: "top 70%",
					scrub: 1,
				}
			});
		})

	}) */





	return {
		init: function (el) {

			// check anchor/hash url
			if(window.location.hash) {
				const urlHash = window.location.hash;
				//console.log(urlHash);
				if(document.querySelector(urlHash)){
					//console.log(document.querySelector(urlHash));
					setTimeout(() => {
						scrollToElm(urlHash, 50);
					}, 2000);
				}
			}

			$(document).on('click', '[data-scrollto]', function (e) {
				e.preventDefault();
				elmToScroll($(this));
			});

			parallaxWebdoor('.webdoor-intro');
			fxTextTitles();
			zoomOutElm();
			introLeft();
			introUp();
			zoomInElm();
			mozaico();
			// listAnimate();
			// limitWhatsScroll();

		}
	}

}();

module.exports = ScrollEvents;